import { notify } from 'components/Common/Toast';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { selectHasPortalStaffAccess, selectPortalContextReady } from 'redux/selectors/parishContext';
import { RootState } from 'redux/store';
import MuiLoader from 'components/Common/Loader';

/**
 * Staff-only routes. Approved contract (§2.6): gate on effective role for
 * selectedParishId from GET /v1/me.staffRoles — not JWT claims, not a my-role API.
 * Wait for /me + /me/parishes hydration before denying (avoids boot flash + toast spam).
 */
const RequireMerchant = () => {
    const ready = useSelector(selectPortalContextReady);
    const hasStaffAccess = useSelector((state: RootState) => selectHasPortalStaffAccess(state));
    const location = useLocation();
    const deniedToastShown = useRef(false);

    if (!ready) {
        return <MuiLoader loading absolute />;
    }

    if (!hasStaffAccess) {
        if (!deniedToastShown.current) {
            deniedToastShown.current = true;
            notify('You have a lower role to continue!', 'warning');
        }
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    deniedToastShown.current = false;
    return <Outlet />;
};

export default RequireMerchant;
